<template>
  <div class="vedio_wrapper">
    <video
      id="videoPlay"
      :src="path"
      :autoplay="false"
      :controls="!show"
      @ended="goEnded"
      >
      your browser does not support the video tag
    </video>
    <img   v-if="show" style="position:absolute; top:calc(50% - 75px);width:130px;left:calc(50% - 75px)"  @click="playVideo" src="../assets/img2/video_paly_large.png" /> 
  </div>
</template>
<script>
export default {
  name: "Vedio",
  props:['path'],
  data(){
     return{
       show:true
     }
  },
  mounted() {
    //this.playVideo();
  },
  methods: {
    playVideo () {
      const vdo = document.getElementById("videoPlay");
      vdo.play();
      this.show =false;
    },
    goEnded(){
      this.show =true;
    }
  }
};
</script>
<style lang="less" scoped>
div.vedio_wrapper {
  position: relative;
  height: 100%;
  > video {
   // position: absolute;
    width: 100%;
    z-index: 15;
  }
}
</style>